var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 70,
    viewBox: "0 0 66 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0221 15.9635C42.4646 12.9504 41.9972 4.8572 41.9284 3.62489C41.7785 4.88002 36.8558 6.97889 30.5832 8.42465C24.2884 9.87555 18.9282 10.1398 18.2746 9.06386C18.7357 10.1672 21.9152 17.8134 22.7453 20.8199C23.6237 24.001 24.4784 30.946 24.4784 30.946L24.4786 30.9467C24.7621 32.1768 29.7941 32.0671 35.7178 30.7017C41.6416 29.3364 46.2139 27.2324 45.9304 26.0023L45.9302 26.0016C45.9302 26.0016 43.6305 19.2521 43.0221 15.9635Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2616 23.7757C53.0387 27.1469 45.9565 31.6572 36.4432 33.8499C26.9299 36.0426 18.588 35.0872 17.811 31.7162C17.034 28.3449 25.523 29.9386 35.0363 27.7459C44.5496 25.5532 51.4846 20.4044 52.2616 23.7757Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9809 24.038C46.9737 24.5461 47.4649 25.7913 47.0743 26.8689C46.4114 28.6974 44.4004 29.4899 42.7846 30.0321C40.2773 30.8735 37.7273 31.7904 35.1626 32.4061C32.5759 33.0271 25.218 34.1545 19.7442 32.3C19.0731 32.0727 18.409 31.8152 17.774 31.4937C17.7821 31.5656 17.7935 31.639 17.8113 31.7161C18.5883 35.0874 26.9301 36.0426 36.4434 33.8499C45.9568 31.6572 53.0389 27.1469 52.2618 23.7756C51.8341 21.9207 49.5409 22.6457 45.9809 24.038Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2212 29.3953C26.0328 29.8951 28.1387 29.7695 29.9486 29.4662C31.11 29.2716 32.2407 28.937 33.38 28.6454C34.5405 28.3482 35.7184 28.125 36.88 27.8317C37.9958 27.55 39.0959 27.2078 40.2102 26.919C40.3665 26.8785 40.5228 26.8376 40.679 26.797C40.5866 26.6545 40.5129 26.4952 40.4656 26.3229C40.4503 26.2677 40.4402 26.2125 40.4325 26.157C38.757 26.7438 36.9501 27.3048 35.0365 27.7459C30.7817 28.7266 26.7325 28.9498 23.6249 29.1987C23.8184 29.2717 24.0162 29.3389 24.2212 29.3953Z",
    fill: "#242424"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9195 3.46618L41.4523 3.57389C40.5174 4.71582 39.1436 5.42841 37.844 6.06337C37.6851 6.14081 37.5176 6.1866 37.3497 6.20212C36.5375 6.53522 35.6886 6.76613 34.8881 7.12855C34.79 7.17297 34.689 7.20554 34.5871 7.22902C34.9598 8.01504 35.314 8.81021 35.6288 9.62467C36.8237 12.7187 37.4336 16.0355 36.5119 19.2439C35.737 21.9409 33.8294 24.2733 31.4777 25.5103C29.1506 26.7344 26.3492 26.7775 23.8832 25.7183C23.8262 25.6938 23.7716 25.666 23.7154 25.6405C24.1614 28.3722 24.4783 30.9463 24.4783 30.9463L24.4784 30.947C24.762 32.1771 29.794 32.0674 35.7177 30.702C41.6414 29.3366 46.2138 27.2327 45.9302 26.0026L45.9301 26.0019C45.9301 26.0019 43.6305 19.2523 43.0222 15.9637C42.4181 12.6983 41.9195 3.46618 41.9195 3.46618Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.694 22.1827C43.7249 23.4177 39.6889 25.0955 34.6912 26.2475C29.702 27.3974 25.3458 27.6567 23.926 26.9749C24.2581 29.1546 24.4786 30.946 24.4786 30.946L24.4788 30.9466C24.7623 32.1768 29.7943 32.067 35.718 30.7017C41.6418 29.3363 46.2141 27.2324 45.9306 26.0022L45.9304 26.0016C45.93 26.0017 45.3491 24.2966 44.694 22.1827Z",
    fill: "#E8C754"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9214 3.46576C42.2049 4.69568 37.1285 6.91603 30.5832 8.42465C24.0379 9.93328 18.5019 10.1592 18.2183 8.92906C17.9346 7.69918 23.011 5.47906 29.5563 3.97043C36.1017 2.4618 41.6379 2.23584 41.9214 3.46576Z",
    fill: "#242424"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3193 43.5394C21.5637 42.8713 21.6863 42.304 21.6863 41.8361C21.6863 40.991 21.4023 40.4594 20.8335 40.2414C20.2655 40.0241 19.4468 39.9162 18.3782 39.9162V38.9478H26.4363V39.9162C25.0054 39.9162 23.981 40.8288 23.3633 42.654L13.8509 70H13.0128L3.07361 42.4367C2.68095 41.313 2.26966 40.6115 1.8382 40.3337C1.40751 40.0559 0.814633 39.9162 0.0595703 39.9162V38.9478H13.0128V39.9162C10.6405 39.9162 9.45479 40.506 9.45479 41.6855C9.45479 41.975 9.51842 42.2481 9.64569 42.5035L15.6001 59.9498L21.3193 43.5394Z",
    fill: "url(#paint0_linear_14238_28664)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0657 64.5237C38.0657 67.0395 39.3097 68.2967 41.7999 68.2967V69.2481H28.1265V68.2967C30.616 68.2967 31.8607 67.0387 31.8607 64.5237V43.6721C31.8607 41.1679 30.616 39.9162 28.1265 39.9162V38.9478H41.7999V39.9162C39.3097 39.9162 38.0657 41.1679 38.0657 43.6721V64.5237Z",
    fill: "url(#paint1_linear_14238_28664)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0622 64.5237C53.0622 65.6924 53.3486 66.6135 53.922 67.2863C54.4955 67.9599 55.2917 68.2967 56.3114 68.2967V69.2481H43.667V68.2967C44.6572 68.2967 45.4363 67.9599 46.0043 67.2863C46.5732 66.6135 46.8572 65.6924 46.8572 64.5237V43.6721C46.8572 42.5035 46.5755 41.5854 46.0113 40.9173C45.4479 40.2491 44.6665 39.9154 43.6662 39.9154V38.9478H56.1189C58.2755 38.9478 60.103 39.2481 61.603 39.8495C63.1031 40.4501 64.25 41.6134 65.0431 43.3385C65.6406 44.6297 65.9402 45.9932 65.9402 47.4288C65.9402 49.9105 65.0385 51.9421 63.235 53.5221C61.6279 54.9352 59.358 55.6422 56.4278 55.6422H53.0614V64.5237H53.0622ZM53.0622 54.2066C54.6794 54.1623 56.0266 53.921 57.1053 53.4802C58.1839 53.041 58.918 52.0531 59.3107 50.5174C59.5947 49.5598 59.7367 48.53 59.7367 47.4288C59.7367 46.1492 59.5559 44.8967 59.1935 43.6721C58.5075 41.535 57.2038 40.4664 55.2824 40.4664C54.4683 40.5332 53.8957 40.6418 53.5627 40.7916C53.2291 40.9421 53.063 41.4683 53.063 42.3692V54.2066H53.0622Z",
    fill: "url(#paint2_linear_14238_28664)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14238_28664",
    x1: 13.2703,
    y1: 34.485,
    x2: 23.3912,
    y2: 69.6346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0402,
    stopColor: "#813E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1025,
    stopColor: "#975100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#BA7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#EB9B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#FFF78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14238_28664",
    x1: -2.44595,
    y1: 38.7519,
    x2: 1.29285,
    y2: 75.4081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0402,
    stopColor: "#813E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1025,
    stopColor: "#975100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#BA7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#EB9B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#FFF78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14238_28664",
    x1: 45.5803,
    y1: 37.4459,
    x2: 60.7019,
    y2: 69.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0402,
    stopColor: "#813E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1025,
    stopColor: "#975100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#BA7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#EB9B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#FFF78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    stopColor: "#F3A200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793700"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipIcon);
export default __webpack_public_path__ + "static/media/vip-icon.e65c7438041e4d2669cd39f356037753.svg";
export { ForwardRef as ReactComponent };